<template>
<div>
    <div class="content-grid">
        <div class="row align-items-stretch no-gutters">
            <div class="col-lg-12">
                <div class="card map_card">
                    <div class="card-header">
                        <img src="../assets/img/marker.png">
                        <span>{{ $t("Overview.hotspotdetails") }} </span>
                    </div>
                    <div class="card-body" style="z-index: 0;" >
                        <div id="myMap">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import JQuery from 'jquery'
import ApiServices from '../service/ApiServices'
import markerUrl from './marker.png'
let $ = JQuery

export default {
    data() {
        return {
            map: null,
            tileLayer: null,
            userData: JSON.parse(sessionStorage.getItem('userData')),
            alllocations: [],
            fromDate: '',
            toDate: '',
        }
    },
    methods: {
        initMap() {
            this.map = new L.map('myMap').setView([12.8797, 121.7740], 6);
            this.tileLayer = new L.tileLayer(
                'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png', {
                    maxZoom: 18,
                    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
                }
            )
            this.tileLayer.addTo(this.map)
            // var marker = new this.L.Marker([17.385044, 78.486671]);
            // marker.addTo(this.map);
        },
        initRealTimeGoogleMaps(alllocations) {
            let self = this
            this.$root.isLoading = true

            // {"language":"en","programid":"U1nNSk2geJh","orguid":"lkaOHazCzow","fromdate":"2021-01-01","todate":"2022-08-09"}
            var instance = {
                "language": "en",
                "programid": this.userData.programid,
                "orguid": this.userData.organisationUnits[0].id,
                "fromdate": this.fromDate,
                "todate": this.toDate
            }
            ApiServices.RestPostCall('dashboardIndicator/realtimemap', instance).then(res => {
                console.log(res)
                this.$root.isLoading = false
                alllocations = res.data
                $.each(alllocations, function (key, val) {
                    delete val.teiid;
                    delete val.deviceId;
                    delete val.instanceId;
                    delete val.status;
                    delete val.sysUIC;
                });

                var alllatlong = [];
                $.each(alllocations, function (key, val) {
                    var loc = {
                        lat: Number(val.Latitude),
                        lng: Number(val.Longitude)
                    }
                    alllatlong.push(loc);
                });
                if (res.data.length == 0) {
                    alllatlong = [{
                        lat: 0,
                        lng: 0
                    }]
                }
                var bounds = new L.LatLngBounds(alllatlong);
                // var map = L.map('myMap', {
                //     zoom: 5,
                //     layers: [self.tiles]
                // });

                var mcg = L.markerClusterGroup({
                    chunkedLoading: true,
                    //singleMarkerMode: true,
                    spiderfyOnMaxZoom: true
                });
                var myIcon = L.icon({
                    iconUrl: markerUrl,
                    iconSize: [40, 41],
                    iconAnchor: [22, 94],
                    popupAnchor: [-3, -76],
                    // shadowUrl: '../assets/img/marker.png',
                    shadowSize: [68, 95],
                    shadowAnchor: [22, 94]
                });
                // L.marker([50.505, 30.57], { icon: myIcon }).addTo(map);
                for (var i = 0; i < alllocations.length; i++) {
                    var a = alllocations[i];

                    var markerdata = "";
                    $.each(alllocations[i], function (key, val) {
                        if (key == 'UIC' || key == 'Client Type' || key == 'Given Name' || key == 'Age' || key == 'Gender' || key == 'Phone Number' || key == '') {
                            markerdata += "<p class='text-primary capitalise " + key + "'>" + key + ": " + val + "</p>";
                        }
                    })
                    var title = markerdata;
                    if (a['Client Type'] != 'Index') {
                        var marker = L.marker(new L.LatLng(a.Latitude, a.Longitude), {
                            icon: myIcon
                        }, {
                            title: title
                        });
                        marker.bindPopup(title);
                        mcg.addLayer(marker);
                    }
                }
                if (!this.map) {
                    this.initMap()
                }
                this.map.addLayer(mcg);
                this.map.fitBounds(bounds);
                // map.panTo(new L.LatLng(27.5142, -90.4336));
                if (this.userData.programid == '1329111')
                    this.map.setView(new L.LatLng(27.5142, 90.4336), 8);
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        }
    },
    mounted() {
         var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        this.toDate = d.getFullYear() + '-' +
            (('' + month).length < 2 ? '0' : '') + month + '-' +
            (('' + day).length < 2 ? '0' : '') + day;
        this.fromDate = '2021-01-01'
        this.initMap();
        this.initRealTimeGoogleMaps(this.alllocations)
        let langLocal = JSON.parse(sessionStorage.getItem('langLocal'))
        for(let lang in langLocal){
            console.log(lang, langLocal[lang])
            this.$i18n.setLocaleMessage(lang,langLocal[lang])
        }
    }
}
</script>
